import React from "react";

const DummyComp = () => (
  <div className='gridBody  contentBody' style={{ width: "100%" }}>
    <h1 style={{ padding: "50px 15px" }}>Comming Soon</h1>
  </div>
);

export { DummyComp };
